// removed by extract-text-webpack-plugin
module.exports = {"TagsFieldset":"_1SMV9E3z2F1iLKmtvxgngu","childrenRow":"OWBAEEWaJDCZhGs42gvdN","removeLink":"_3ZTt2ho6aRsthY_ItM27DX"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/fieldsets/TagsFieldset.scss
// module id = 1459
// module chunks = 0